module.exports = "<prg-select-light (selected)=\"lightSelected($event)\"></prg-select-light>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-lights/light-action/light-action.component.html
// module id = 1571
// module chunks = 2